<template>

  <div class="home">
    <navbar :is-active="2"></navbar>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
        <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>{{company_name}}</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link to="/Client/cp-productos" class="tab">
            <div class="tab__icon">
              <i class="fab fa-product-hunt"></i>
            </div>
            <div class="tab__text">
              <p>Productos</p>
            </div>
          </router-link>
          <router-link to="/Client/cp-clientes" class="tab">
            <div class="tab__icon">
              <i class="fas fa-user-friends"></i>
            </div>
            <div class="tab__text">
              <p>Clientes</p>
            </div>
          </router-link>
          <router-link to="/Client/cp-boletas" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-file-invoice-dollar"></i>
            </div>
            <div class="tab__text">
              <p>Boletas</p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Detalle Producto </h2>
        </div>
        <div class="page__subtitle">
          <h3>Información </h3>
        </div>
        <section class="page__filters">
          <div class="input"  style="background: #e7e7e7;">
            <p>Nombre</p>
            <span>{{ company_contact_name }}</span>
          </div>
          <div class="input"  style="background: #e7e7e7;">
            <p>Apellido </p>
            <span>{{ company_contact_lastname }}</span>
          </div>
          <div class="input"  style="background: #e7e7e7;">
            <p>DNI </p>
            <span>{{ user_doc_number }}</span>
          </div>
          <div class="input"  style="background: #e7e7e7;">
            <p>Email </p>
            <span>{{ company_contact_email }}</span>
          </div>
          <div class="input" style="background: #e7e7e7;">
            <p>Celular</p>
            <span>{{ company_contact_cellphone }}</span>
          </div>

          <div class="page__subtitle" style="margin-bottom: 0px;">
            <h3>Información de la boleta</h3>
          </div>
          <div class="input"  style="background: #e7e7e7;">
            <p>Código boleta</p>
            <span>{{ codeFormat(invoice_id) }}</span>
          </div>
          <div class="input"  style="background: #e7e7e7;">
            <p>Código Sucursal</p>
            <span>{{ codeFormat(codigo_sucursal) }}</span>
          </div>
          <div class="input"  style="background: #e7e7e7;">
            <p>Nombre Sucursal </p>
            <span>{{ nombre_surcursal }}</span>
          </div>
          <div class="input"  style="background: #e7e7e7;">
            <p>Cantidad de productos </p>
            <span>{{ invoice_amount }}</span>
          </div>
          <div class="input"  style="background: #e7e7e7;">
            <p>Precio </p>
            <span>{{ invoice_price }}</span>
          </div>
          <div class="input"  style="background: #e7e7e7;">
            <p>Estado de Boleta </p>
            <span>{{ estado_boleta }}</span>
          </div>
          <div class="input" style="background: #e7e7e7;">
            <p>Fecha de compra</p>
            <span>{{ fecha_compra }}</span>
          </div>
          <div class="page__table" style="height: 100%; overflow: auto">
            <div class="page__title">
              <h2> <span>Productos </span></h2>
            </div>
            <div class="page__table">
              <div class="table-headers">
                <p>Código Producto</p>
                <p>Nombre Producto</p>
                <p>Marca</p>
                <p>Tipo</p>
                <p>Cantidad</p>
                <p>Precio</p>
                <p>Precio Total</p>
              </div>
              <div class="table-body">
                <div class="data" v-for="invoice of invoices" :key="invoice.id">
                  <p>{{ invoice.product_code }}</p>
                  <p>{{ invoice.product_name }}</p>
                  <p>{{ invoice.marca }}</p>
                  <p>{{ invoice.tipo }}</p>
                  <p>{{ invoice.invoice_det_product_amount }}</p>
                  <p>{{ invoice.invoice_det_product_price }}</p>
                  <p>{{ ((invoice.invoice_det_product_amount * invoice.invoice_det_product_price)) }}</p>

                </div>
              </div>
            </div>
          </div>
        </section>
        <!--        <section class="page__actions">-->
        <!--          <button>-->
        <!--            <span>Cancelar</span>-->
        <!--            <i class="fas fa-upload"></i>-->
        <!--          </button>-->
        <!--          <button @click="saveClient">-->
        <!--            <span>Guardar</span>-->
        <!--            <i class="far fa-trash-alt"></i>-->
        <!--          </button>-->
        <!--        </section>-->
      </div>

    </div>
  </div>

</template>

<script>
// @ is an alias to /src
import axios from "axios";
import Navbar from '@/components/NavBar.vue'
import OpenArrow from '@/components/OpenArrow.vue'
import HiddenArrow from '@/components/HiddenArrow.vue'
import { codeFormat } from '@/utils/formats'

export default {
  name: 'ClienteConciliaDetalleCliente',
  components: {
    Navbar,
    OpenArrow,
    HiddenArrow
  },
  data(){
    return{
        tag: 0,
        branchoffice: '',
        company_name:'',
        company_ruc:'',
        created_at:'',
        user_doc_number: '',
        company_contact_cellphone:'',
        company_contact_email:'',
        company_contact_lastname:'',
        company_contact_name:'',
        B2C: null,
        invoice_id: '',
        invoices: [],
        codigo_sucursal: '',
        estado_boleta: '',
        nombre_surcursal: '',
        invoice_amount: '',
        invoice_price: '',
        fecha_compra: '',
    }
  },
  created() {
    this.company_name = localStorage.getItem('company_name');
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id');
    // this.getall(id);
    this.getallb2c(id);
  },
  methods:{
    codeFormat,
    async getallb2c(id) {
        await axios.get('general/search/invoice/'+id).then( res => {

          //cliente
          this.company_contact_name = res.data.data.user_name
          this.company_contact_lastname = res.data.data.user_lastname
          this.user_doc_number = res.data.data.user_doc_number
          this.company_contact_email = res.data.data.email
          this.company_contact_cellphone = res.data.data.cellphone
          //boleta
          this.invoice_id = res.data.data.id
          this.codigo_sucursal = res.data.data.branch_code
          this.nombre_surcursal = res.data.data.branch_name //traerlo
          this.invoice_amount = res.data.data.invoice_amount
          this.invoice_price = res.data.data.invoice_price
          this.estado_boleta = res.data.data.estado //traerlo
          this.fecha_compra = res.data.data.invoice_date_purchase

          this.invoices = res.data.data.det

        })
    },
    async getall(id){
      const { data } = await axios.get('general/conciliation/findClient/'+id);

      this.branchoffice = data.data;
      this.company_contact_cellphone = data.data.cliente.cellphone;
      this.company_contact_name = data.data.cliente.user_name;
      this.company_contact_lastname = data.data.cliente.user_lastname;
      this.company_contact_email = data.data.cliente.email;
      this.user_doc_number = data.data.cliente.user_doc_number;
      this.invoice_id = this.branchoffice.invoices[0].id;
      this.codigo_sucursal = this.branchoffice.invoices[0].codigo_sucursal;
      this.nombre_surcursal = this.branchoffice.invoices[0].nombre_surcursal;
      this.fecha_compra = this.branchoffice.invoices[0].fecha_compra;
      this.estado_boleta = this.branchoffice.invoices[0].estado_boleta;
      this.invoice_price = this.branchoffice.invoices[0].invoice_price;
      this.invoice_amount = this.branchoffice.invoices[0].invoice_amount;
    },

    // async getallb2c(id){
    //   const { data } = await axios.get('general/search/invoice/'+id);
    //   console.log('+++++++++++++++++++++++++++++++++++')
    //   console.log('+++++++++++++++++++++++++++++++++++')
    //   this.product = data.data.products
    //   console.log(this.product)
    //   this.product_name = data.data.product_name
    //   this.product_name = data.data.marca
    //   this.product_name = data.data.tipo
    //   this.product_name = data.data.product_code
    //   this.product_name = data.data.product_price
    // },
    // async getinvoice(id){
    //     const {data} = await axios.get('general/invoice' + id);
    //     this.
    // }

    changePage(url) {
      this.$router.push(url)
    },
    handleClick(){
      localStorage.removeItem('token')
      this.$router.push('/login')
    },
    backCompany(){
      this.$router.push('/comercial')
    },
    async saveClient(){
      try {
        const json = {
          "company_ruc": this.company_ruc,
          "company_name": this.company_name ,
          "company_bus_group_id": "1",
          "company_bus_type_id": "1",
          "company_cus_type_id": "1",
          "company_gat_connection_id": "1",
          "company_rec_type_id": "1",
          "company_status": "1"
        }
        const valores = window.location.search;
        const urlParams = new URLSearchParams(valores);
        const id = urlParams.get('id');

        const response = await axios.put('general/company/'+id, json)


        if(response.status === 200){
          this.$swal({
            position: 'center',
            icon: 'success',
            title: 'Editado correctamente',
            showConfirmButton: false,
            timer: 2000
          })
          this.$router.push('/ClientesB2C')
        }
      } catch (error) {
        console.log(error)
        this.$swal({
          position: 'center',
          icon: 'error',
          title: 'Completar los datos correctamente',
          showConfirmButton: false,
          timer: 2000
        })
      }
    }
  }
}


</script>

<style scoped>
.back_company {
  background: #000;
  color: white;
  width: 100%;
  padding-top: 3%;
  padding-left: 10%;
}


/*------NAVBAR------*/
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}

.home .navbar {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .navbar__left img {
  width: 130px;
}

.home .navbar__center ul li.active {
  color: #ff3128;
}
.home .navbar__center ul li.active::before {
  width: 100%;
}

.home .navbar__center {
  width: 70%;
  height: 100%;
}

.home .navbar__center ul{
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
  display: flex;
  justify-content: flex-start;
}
.home .navbar__center ul li {
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}

.home .navbar__center ul li::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 4px;
  background-color: #ff3128;
  transition: .3s ease;
}
.home .navbar__center ul li:hover {
  color: #ff3128;
}
.home .navbar__center ul li:hover::before {
  width: 100%;
}

.home .navbar__right {
  display: flex;
  width: 20%;
}
.home .navbar__right .profile {
  display: flex;
  width: 100%;
  height: 100%;
}

.home .navbar__right .profile__detail{
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
}
.home .navbar__right .profile__detail p {
  margin: 0;
}
.home .navbar__right .profile__detail span {
  color: #938f8f;
  font-weight: 300;

}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #ff3128;
  cursor: pointer;
}
/*------NAVBAR------*/

/*-------------------------*/
a:hover {
  text-decoration: none;
}
/*-------------------------*/

/*------BODY------*/

.body {
  width: 100%;
  height: 600px;
  display: flex;
}
.body__sidebar,
.body__containt  {
  height: calc(100vh - 120px);
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}
.body__sidebar {
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.body__sidebar .floating-icon {
  position: absolute;
  right: -15px;
  top: 50px;
  color: #ff3128;
  font-size: 30px;
}

.body__sidebar .title {
  width: 100%;
  height: 140px;
  border-bottom: 1px solid #b6b6b6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body__sidebar .title__icon {
  color: #ff3128;
  font-size: 20px;
}
.body__sidebar .title__text {
  margin: 0 10px;

}

.body__sidebar .title__text h2 {
  font-size: 20px;
  margin: 0;
}
.body__sidebar .title__text p {
  margin: 0;
  font-weight: 300;
}

.body__sidebar .tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 140px);
  padding-top: 5px;
}

.body__sidebar .tabs .tab {
  width: 90%;
  height: 70px;
  border-radius: 10px;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.3 ease;
}
.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
  color: #ff3128;
  background: #ffeeed;
}

.body__sidebar .tabs .tab__icon {
  font-size: 20px;
  margin-right: 10px;
}

.body__sidebar .tabs .tab__text p{
  margin: 0;
  font-weight: 600;
}
/*----------------------------*/
/*----------------------------*/
/*----------------------------*/
.body__containt {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  overflow-y: scroll;
}
.body__containt .page__subtitle,
.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
}

.body__containt .page__title h2 {
  font-weight: 600;
  color: #000;
  font-size: 25px;
}
.body__containt .page__title h2 span {
  color: #ff3128;
}
.body__containt .page__subtitle h3  {
  color: #ff3128;
  font-weight: 600;
  font-size: 20px;
}

.body__containt .page__table {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}

.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-headers p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
}

.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b6b6b6;
}

.body__containt .page__table .table-body .data {
  width: 100%;
  display: flex;
}
.body__containt .page__table .table-body .data p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
}
.body__containt .page__table .table-body .data p:nth-child(1) {
  color: #ff3128;
}
/*-----FILTERS------*/

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 40px;
}

.body__containt .page__filters .input {
  width: 300px;
  border-radius: 10px;
  border: 1px solid #938f8f;
  display: flex;
  flex-direction: column;
  padding: 7px 15px;
  transition: 0.4s ease;

}

.body__containt .page__filters .input:hover {
  box-shadow: 10px 15px 15px rgba(0, 0, 0, 0.05);
}
.body__containt .page__filters .input:nth-child(5) {
  margin-right: 320px;
}
.body__containt .page__filters .input:nth-last-child(1) {
  width: 1260px;
}
.body__containt .page__filters .input span {
  font-size: 15px;
  color: #938f8f;
}
.body__containt .page__filters .input p {
  margin: 0;
}

.page__filters input, select{
  outline:none;
  border: none;
  background: white;
}

/*-----PRODUCT------*/
.page__product {
  width: 100%;
  display: flex;
  padding-bottom: 50px;
  border-bottom: 1px solid #938f8f;
}

.page__product .product__image,
.page__product .product__buttons {
  /* width: 50%; */
  display: flex;
  align-items: center;
}
.page__product .product__image {
  width: 400px;
  justify-content: center;
  border-radius: 10px;
  overflow: hidden;
}

.page__product .product__image img {
  width: 100%;
  object-fit: cover;
  transition: 1s ease;
}
.page__product .product__image img:hover {
  transform: scale(1.1) rotate(1deg);
}
.page__product .product__buttons {
  width: 500px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
}
.page__actions button,
.page__product .product__buttons button {
  width: 350px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
  border: none;
  border-radius: 15px;
  color: #fff;
  transition: 0.4s ease;
}
.page__actions button:hover,
.page__product .product__buttons button:hover {
  transform: scale(1.1);
}
.page__actions button:nth-child(2),
.page__product .product__buttons button:nth-child(1) {
  background: #32ba7c;
}
.page__product .product__buttons button:nth-child(2) {
  background: #262626;
}
.page__product .product__buttons button:hover:nth-child(2) {
  background: #ff3128;
}

/*------------------------*/
/*------------------------*/
/*------------------------*/

.page__actions {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 30px 0;
  gap: 20px;
}

.page__actions button:nth-child(1) {
  background: #ff3128;
}

/*------BODY------*/
  .body__sidebar.open{
    display: none;
  }

</style>
